// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J2k-2","rootNoMargin":"styles_rootNoMargin__3geiN"};